import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PasswordForgetLink } from '../PasswordForget';
import { auth } from '../../firebase';
import firebase from 'firebase';
import * as routes from '../../constants/routes';
import { Link } from 'react-router-dom';
import '../css/signin.css';
import '../css/main.css';
import '../css/util.css';

const SignInPage = ({ history }) =>
    <div  className="container_login">
    {console.log(history)}
      <div className="signin">
        <div className="limiter">
          <div>
            <img src={require('../../images/logo.png')} className="logo"/>
            <h2 style={{color : '#F2994A'}}>Sri Universal Suraksha Card</h2>
          </div>
          <h6>Sign in to you account</h6>
          <SignInForm history={history} />
          <PasswordForgetLink />
        </div>
      </div>
    </div>

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {email,password,} = this.state;
    const {history, toggle} = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        var uid = firebase.auth().currentUser.uid;
        firebase.database().ref('users/admin/details').once('value',function(snap){
          if(snap.hasChild(uid)){
            history.push(routes.ADMIN);
          }
          else{
            history.push(routes.HOME);
          }
        })
      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';

    return (
      <div>
        {/* <Link to={routes.MAIN}><a id="root_home" className="m-t-5 m-r-5 home_button" >Home</a></Link> */}
        <div>
          <form onSubmit={this.onSubmit} className="login100-form">
            <input
              value={email}
              onChange={event => this.setState(updateByPropertyName('email', event.target.value))}
              type="text"
              placeholder="Email Address"
              className="wrap-login100"
            />
            <input
              value={password}
              onChange={event => this.setState(updateByPropertyName('password', event.target.value))}
              type="password"
              placeholder="Password"
              className="wrap-login100"
            />
            <button disabled={isInvalid} type="submit" className="container-login100">
              Sign In
            </button>
            { error && <div className="error">{error.message}</div> }

          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(SignInPage);

export {
  SignInForm,
};
